/** Ray helpers used by server hitreg (and client effects). */
/** Slab-method ray/AABB intersection. Returns entry distance or null. */
export function rayAabb(ray, box, maxDist = Infinity) {
    let tmin = 0;
    let tmax = maxDist;
    // Unrolled per axis. The readable version built a fresh 3x4 nested array
    // literal and destructured a swap tuple on EVERY call — and bot line-of-sight
    // calls this thousands of times per tick. The arithmetic below is identical
    // axis for axis, so results stay bit-exact (this is shared with hitscan, which
    // is server-authoritative).
    for (let axis = 0; axis < 3; axis++) {
        const o = axis === 0 ? ray.ox : axis === 1 ? ray.oy : ray.oz;
        const d = axis === 0 ? ray.dx : axis === 1 ? ray.dy : ray.dz;
        const min = axis === 0 ? box.minX : axis === 1 ? box.minY : box.minZ;
        const max = axis === 0 ? box.maxX : axis === 1 ? box.maxY : box.maxZ;
        if (Math.abs(d) < 1e-9) {
            if (o < min || o > max)
                return null;
            continue;
        }
        const inv = 1 / d;
        const ta = (min - o) * inv;
        const tb = (max - o) * inv;
        const t1 = ta > tb ? tb : ta;
        const t2 = ta > tb ? ta : tb;
        if (t1 > tmin)
            tmin = t1;
        if (t2 < tmax)
            tmax = t2;
        if (tmin > tmax)
            return null;
    }
    return tmin;
}
export function yawPitchToDir(yaw, pitch) {
    const cp = Math.cos(pitch);
    return [-Math.sin(yaw) * cp, Math.sin(pitch), -Math.cos(yaw) * cp];
}
//# sourceMappingURL=raycast.js.map